import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PromptPreview = ({ prompt, characterCount, onCopy, onOptimize, isOptimizing, isEnhancing }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    onCopy();
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const getCharacterCountColor = () => {
    if (characterCount < 100) return 'text-warning';
    if (characterCount > 2000) return 'text-error';
    return 'text-success';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 space-y-4 h-full flex flex-col">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">Prompt Preview</h3>
        <div className="flex items-center gap-2">
          <span className={`text-sm font-medium ${getCharacterCountColor()}`}>
            {characterCount} characters
          </span>
        </div>
      </div>

      <div className="flex-1 min-h-[200px] md:min-h-[300px] bg-muted rounded-lg p-4 overflow-y-auto custom-scrollbar">
        {isEnhancing ? (
          <div className="flex items-center justify-center h-full">
            <div className="text-center space-y-3">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary mx-auto"></div>
              <p className="text-muted-foreground text-sm font-medium">Enhancing your prompt...</p>
              <p className="text-muted-foreground text-xs">This may take a few moments</p>
            </div>
          </div>
        ) : prompt ? (
          <pre className="text-sm text-foreground whitespace-pre-wrap font-mono leading-relaxed">
            {prompt}
          </pre>
        ) : (
          <div className="flex items-center justify-center h-full">
            <p className="text-muted-foreground text-center">
              Your generated prompt will appear here
            </p>
          </div>
        )}
      </div>

      <div className="flex flex-col sm:flex-row gap-2">
        <Button
          variant="outline"
          onClick={handleCopy}
          disabled={!prompt || isEnhancing}
          iconName={copied ? "Check" : "Copy"}
          iconPosition="left"
          fullWidth
        >
          {copied ? 'Copied!' : 'Copy to Clipboard'}
        </Button>
        <Button
          variant="default"
          onClick={onOptimize}
          disabled={!prompt || isOptimizing || isEnhancing}
          loading={isOptimizing}
          iconName="Sparkles"
          iconPosition="left"
          fullWidth
        >
          Optimize Prompt
        </Button>
      </div>

      <div className="flex items-start gap-2 p-3 bg-primary/10 rounded-lg">
        <Icon name="Lightbulb" size={16} className="text-primary mt-0.5 flex-shrink-0" />
        <p className="text-xs text-muted-foreground">
          <strong className="text-foreground">Pro Tip:</strong> More specific details lead to better AI results. Include context, constraints, and desired output format.
        </p>
      </div>
    </div>
  );
};

export default PromptPreview;